// extracted by mini-css-extract-plugin
export default {"heading":"DeliveryOption_heading__E8e3l","wrapper":"DeliveryOption_wrapper__E+oIc"};